const summaryCache = new Map();
const SUMMARY_CACHE_TTL_MS = 60 * 1000;

export function getCachedRecipientSummary(recipientId) {
    const cached = summaryCache.get(recipientId);
    if (!cached) return null;

    if (cached.expiresAt <= Date.now()) {
        summaryCache.delete(recipientId);
        return null;
    }

    return cached.summary;
}

export function setCachedRecipientSummary(recipientId, summary) {
    summaryCache.set(recipientId, {
        summary,
        expiresAt: Date.now() + SUMMARY_CACHE_TTL_MS
    });
}

export function clearRecipientSummaryCache(recipientId) {
    if (recipientId) {
        summaryCache.delete(recipientId);
    } else {
        summaryCache.clear();
    }
}



// WEBPACK FOOTER //
// ./src/lib/recipientSummaryCache.js